import libraryObjectTypes from 'helpers/enums/entityTypes'

function getLessonIdFromEntity(entityType, lessonData) {
	let lessonId
	switch (entityType) {
		case libraryObjectTypes.LESSON:
			lessonId = lessonData.data.entityUID
			break
		case libraryObjectTypes.BUNDLE:
			lessonId = lessonData.data.defaultNppUID
			break
		default:
			lessonId = ''
			break
	}
	return lessonId
}

export default getLessonIdFromEntity
